import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	Card,
	CardHeader,
	CardBody,
	Table
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
const GLOBAL = require('../../Globals');
const tableStyle = {
	border: "1px solid black",
	borderCollapse: 'collapse'
};

class ReportCard extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			acyear: '',
			cls: '',
			section: '',
			examname: '',
			subject: '',
			_message: '',
			alertClass: '',
			_redirect: false,
			posts: [],
			accyear: [],
			exams: [],
			subj: [],
			modal: false,
			modal1: false,
			modal2: false,
			modal3: false,
			timetab: [],
			data: [],
			marks: [],
			markdata: [],
			marktotal: [],
			abserve: [],
			grade: [],
			ssubj: [],
			sections: [],
			sec: [],
			students: [],
			allocateClass: [],
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onView = this.onView.bind(this);
		this.toggle = this.toggle.bind(this);
		this.printDocument = this.printDocument.bind(this);
	}

	printDocument() {

		var content = document.getElementById("reportcard");
		var pri = document.getElementById("print_frame").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}

	/** set value **/
	onChange(e) {
		this.state.acyear = e.target.value;
		this.getexam();
		this.getallocatesection();
	}

	onClassChange(e) {
		this.state.cls = e.target.value;
		this.getsection();
		this.getmainsubject();
		this.getsubsubject();
	}
	onSecChange(e) {
		this.state.section = e.target.value;
		this.getstudent();
		this.getmark();
		this.getabserve();
	}
	onStudChange(e) {
		this.state.student = e.target.value;
		this.getdata();
	}

	onInputChange(id, e) {

		var index = this.state.marks.findIndex(function (obj) {

			return (obj.id == id);
		});

		if (index === -1) {

			this.state.marks.push({ "id": id, "mark": e.target.value, "remarks": 0 });
		}
		else {

			this.state.marks[index].mark = e.target.value;
		}
		console.log(this.state.marks);
	}

	onRemarkChange(id, e) {

		var index = this.state.marks.findIndex(function (obj) {
			return (obj.id == id);
		});

		if (index != -1) {

			this.state.marks[index].remarks = e.target.value;

		}
	}

	onClick(e) {

		document.getElementById("examform").reset();
	}

	onSubmit(e) {
		e.preventDefault();
		$("#showLoader").show();
		PostData('exam/saveexammarks', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson.status == '1') {
				this.setState({
					_message: 'Marks Added Successfully!..',
					alertClass: 'alert alert-success',
				});
				this.setState({ marks: '' });
				document.getElementById("markform").reset();
			}
			else {

				this.setState({
					_message: 'Invalid Key',
					alertClass: 'alert alert-danger'
				});
			}
		});
	}

	onView() {

		this.state.idd = dt;
		this.setState({ _redirect: true });
	}

	componentWillMount() {

		this.getacyear();
		this.getclass();
		this.getgrade();
	}

	//get allocate section details
	getallocatesection() {

		GetData('section/getsecbyacyear/' + this.state.acyear).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					sections: responseJson
				});
			}
		});
	}

	/** get Academic Year **/
	getacyear() {
		$("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				
				let userData = JSON.parse(sessionStorage.getItem('userData'));
				this.state.userId = userData['userid'];
				this.state.userRole = userData['userrole'];
				this.state.staffid = userData['staffid'];
				this.setState({
					staffid: userData['staffid']
				});
				
				if(userData['userrole'] == 'classteacher'){
					this.checkclassteacher();
				}
				
				this.getallocatesection();
				this.getexam();
			}
		});
	}
	
	checkclassteacher(){
		$("#showLoader").show();
		GetData('employee/checkclassteacher/'+this.state.acyear+'/'+this.state.staffid).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					allocateClass : responseJson
				});
			}
			$("#showLoader").hide();
		});
	}

	getgrade() {
		$("#showLoader").show();
		GetData('exam/getgrade').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					grade: responseJson
				});
			}
		});
	}

	getclass() {
		$("#showLoader").show();
		GetData('classs/getclass').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	// Get Section By Class
	getsection() {
		var dat = [];
		for (var i = 0; i < this.state.sections.length; i++) {

			if (this.state.sections[i].clas == this.state.cls) {
				dat.push(this.state.sections[i]);
			}
		}
		this.setState({ sec: dat });
	}

	getstudent() {
		$("#showLoader").show();
		GetData('student/getstddetailsbymsg/' + this.state.acyear + '/' + this.state.cls + '/' + this.state.section).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					students: responseJson
				});
			}
		});
	}

	getexam() {
		$("#showLoader").show();
		GetData('exam/getexambyacyear/' + this.state.acyear).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.state.marktotal = [];
				this.state.rank = [];
				this.setState({
					exams: responseJson
				});
				this.state.marktotal = new Array(this.state.exams.length);
				this.state.rank = new Array(this.state.exams.length);
			}
		});
	}

	getmainsubject() {
		$("#showLoader").show();
		GetData('assignsubject/getmainsubbycls/' + this.state.acyear + '/' + this.state.cls).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					subj: responseJson
				});
			}
		});
	}

	getsubsubject() {
		$("#showLoader").show();
		GetData('assignsubject/getsubsubbycls/' + this.state.acyear + '/' + this.state.cls).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					ssubj: responseJson
				});
			}
		});
	}

	getdata() {

		$("#showLoader").show();
		GetData('student/getstudentbyview/' + this.state.acyear + '/' + this.state.cls + '/' + this.state.section + '/' + this.state.student).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					data: responseJson
				});
				$("#stdname").html(this.state.data[0]['stdname']);
				$("#stdcls").html(this.state.data[0]['cls']);
				$("#stdsec").html(this.state.data[0]['sec']);
				$("#stdac").html(this.state.data[0]['ac']);
			}
		});
	}

	getmark() {
		$("#showLoader").show();
		GetData('exam/getmarkbyclssec/' + this.state.acyear + '/' + this.state.cls + '/' + this.state.section).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					markdata: responseJson
				});
			}
		});
	}

	getabserve() {
		$("#showLoader").show();
		GetData('exam/getabserve/' + this.state.acyear + '/' + this.state.cls + '/' + this.state.section).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					abserve: responseJson
				});
			}
		});
	}

	// Get Main Subject By Class
	getsubjectbycls() {

		var subj = [];
		for (var i = 0; i < this.state.subj.length; i++) {
			subj.push(<td align="center" style={tableStyle}><b>{this.state.subj[i].sub}</b></td>);
		}
		return subj;
	}

	// Get Sub Subject By Class
	getsubbycls() {

		var subj = [];

		for (var i = 0; i < this.state.ssubj.length; i++) {
			subj.push(<td colSpan="2"><b>{this.state.ssubj[i].sub}</b></td>);
		}
		return subj;
	}

	// Get Mark by Subejct and exam
	getmarkbyexam(exam, index) {

		var mar = [];
		var tot = 0;
		var total = 0;
		for (var j = 0; j < this.state.subj.length; j++) {
			if (this.checkmarks(exam, this.state.subj[j].subject) != false) {
				mar.push(<td style={tableStyle} align="center">{parseFloat(this.checkmarks(exam, this.state.subj[j].subject)) == '-1' ? 'AB' : parseFloat(this.checkmarks(exam, this.state.subj[j].subject))}</td>);
				if(parseFloat(this.checkmarks(exam, this.state.subj[j].subject)) != '-1'){
					tot += parseFloat(this.checkmarks(exam, this.state.subj[j].subject));
				}
				total += parseFloat(this.checkmaxmarks(exam, this.state.subj[j].subject));
				this.state.marktotal[index] = tot + '/' + total;
				if (this.checkgrade(tot) != false) {

					this.state.rank[index] = this.checkgrade(tot);
				}
			}
			else {

				mar.push(<td style={tableStyle}></td>);
			}
		}

		return mar;
	}

	// Get Mark by Subejct and exam
	getsubmarkbyexam(exam, index) {

		var mar = [];
		var tot = 0;

		for (var j = 0; j < this.state.ssubj.length; j++) {

			if (this.checkmarks(exam, this.state.ssubj[j].subject) != false) {

				// tot += parseInt(this.checkmarks(exam,this.state.ssubj[j].suborder));
				mar.push(<td style={tableStyle}>{this.checkmarks(exam, this.state.ssubj[j].subject)}</td>);
				//mar.push(<td>{this.checksubgrade(this.checkmarks(exam,this.state.ssubj[j].suborder))}</td>);
			}
			else {
				mar.push(<td></td>);
			}
		}

		return mar;
	}

	checksubgrade(tot) {

		if (tot.trim().length > 0) {

			var mark = parseInt(tot);
		}
		else {

			var mark = tot;
		}
		var mstate = false;

		for (var kk = 0; kk < this.state.grade.length; kk++) {
			// console.log(this.state.grade[kk].lowmark+' <= '+mark+' '+this.state.grade[kk].upmark+' >= '+mark);
			if (this.state.grade[kk].lowmark <= mark && this.state.grade[kk].upmark >= mark) {

				mstate = this.state.grade[kk].grade;
				break;
			}
			else {

				mstate = false;
			}
		}

		return mstate;
	}

	checkgrade(tot) {

		var mstate = false;
		var mark = tot / this.state.subj.length;
		for (var kk = 0; kk < this.state.grade.length; kk++) {
			if (this.state.grade[kk].lowmark <= mark && this.state.grade[kk].upmark >= mark) {
				mstate = this.state.grade[kk].grade;
				break;
			}
			else {
				mstate = false;
			}
		}
		return mstate;
	}

	checkmarks(exam, sub) {

		var bstate = false;

		var stdregno = $("#stud").val();

		for (var jj = 0; jj < this.state.markdata.length; jj++) {

			if (this.state.markdata[jj].examname == exam && this.state.markdata[jj].subject == sub && this.state.markdata[jj].studentid == stdregno) {

				bstate = this.state.markdata[jj].mark;
				break;
			}
			else {

				bstate = false;
			}
		}

		return bstate;
	}

	checkmaxmarks(exam, sub) {

		var bstate = false;

		var stdregno = $("#stud").val();

		for (var jj = 0; jj < this.state.markdata.length; jj++) {

			if (this.state.markdata[jj].examname == exam && this.state.markdata[jj].subject == sub && this.state.markdata[jj].studentid == stdregno) {

				bstate = this.state.markdata[jj].maxmark;
				break;
			}
			else {

				bstate = false;
			}
		}

		return bstate;

	}

	getremarks(exam) {

		var ab = [];

		if (this.checkabserve(exam) != false) {

			ab.push(<td style={tableStyle}>{this.checkabserve(exam)}</td>);
		}
		else {

			ab.push(<td style={tableStyle}></td>);
		}
		return ab;
	}

	checkabserve(exam) {

		var bstate = false;

		var stdregno = $("#stud").val();

		for (var k = 0; k < this.state.abserve.length; k++) {

			if (this.state.abserve[k].exam == exam && this.state.abserve[k].regno == stdregno) {

				bstate = this.state.abserve[k].remarks;
				break;
			}
			else {

				bstate = false;
			}
		}

		return bstate;

	}
	
	checkClass(cls){
		var bstate = false;
		var d = this.state.allocateClass;
		var index = d.findIndex(function(obj){
			return(obj.class == cls);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}
	
	checkSection(sec){
		var bstate = false;
		var d = this.state.allocateClass;
		var index = d.findIndex(function(obj){
			return(obj.section == sec);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}

	render() {

		if (this.state._redirect) {

			return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

		}

		var exa = this.state.exams;
		var items = this.state.posts;
		var acyear = this.state.accyear;
		var sub = this.state.subj;
		var secs = this.state.sec;
		var stud = this.state.students;

		if (this.state.acyear != '' && this.state.cls != '' && this.state.section != '' && this.state.student) {

			$("#reportcard").show();
		}
		else {

			$("#reportcard").hide();
		}

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<form action="" method="post" role="form" id="markform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<Row>
							<Col md="12">
								<Card>
									<CardHeader>
										<strong>Report Card</strong>
										<span style={{float : 'right'}}>
											<ReactHTMLTableToExcel
												id="test-table-xls-button"
												className="download-table-xls-button"
												table="table-to-xls"
												filename="tablexls"
												sheet="tablexls"
												buttonText="Download as XLS" />
										</span>
										<Row>
											<Col md={3} sm={12} xs={12}>
												<label>Academic Year</label>
												<select name="acyear" onChange={this.onChange} className="form-control" required id="year">
													<option value="">Select Academic Year</option>
													{
														acyear.map(function (item) {
															return <option value={item.id}>{item.value}</option>;
														})
													}
												</select>
											</Col>
											<Col md={3} sm={12} xs={12}>
												<label>Class</label>
												<select name="cls" onChange={this.onClassChange.bind(this)} className="form-control" required id="clas">
													<option value="">Select Class</option>
													{(this.state.userRole == 'classteacher') ?
														items.map((item)=>{
															if(this.checkClass(item.id)){
																return <option value={item.id}>{item.class}</option>;
															}
														})
														:
														items.map(function (item) {
															return <option value={item.id}>{item.class}</option>;
														})
													}
												</select>
											</Col>
											<Col md={3} sm={12} xs={12}>
												<label>Section</label>
												<select name="section" onChange={this.onSecChange.bind(this)} className="form-control" id="secs" required>
													<option value="">Select Section</option>
													{(this.state.userRole == 'classteacher') ?
														secs.map((item)=>{
															if(this.checkSection(item.section)){
																return <option value={item.section}>{item.secs}</option>;
															}
														})
														:
														secs.map(function (item) {
															return <option value={item.section}>{item.secs}</option>;
														})
													}
												</select>
											</Col>
											<Col md={3} sm={12} xs={12}>
												<label>Student</label>
												<select name="student" onChange={this.onStudChange.bind(this)} className="form-control" required id="stud">
													<option value="">Select Student</option>
													{
														stud.map(function (item) {
															return <option value={item.regno}>{item.stdname}</option>;
														})
													}
												</select>
											</Col>
										</Row>
										
										{/*<Button size="sm" className="btn-right" color="warning" onClick={this.printDocument}><i className="fa fa-print"></i> Print</Button>*/}
									</CardHeader>
									<CardBody>
										<Row id="reportcard">
											<Col md="12">
												<table responsive id="table-to-xls">
													<tr>
														<td width="100%" align="center" style={{ textTransform: 'uppercase', fontSize: '20px', border: '1px solid black' }}><b>{GLOBAL.Sclful_NAME}</b></td>
													</tr>
													<tr>
														<td width="100%" style={tableStyle}>
															<table width="100%">
																<tr>
																	<td>
																		<b>Name : </b><span id="stdname"></span>
																	</td>
																	<td>
																		<b>Class : </b><span id="stdcls"></span>
																	</td>
																	<td>
																		<b>Section : </b><span id="stdsec"></span>
																	</td>
																	<td>
																		<b>Academic Year : </b><span id="stdac"></span>
																	</td>
																</tr>
															</table>
														</td>
													</tr>
													<tr>
														<td width="100%">
															<table width="100%">
																<tr>
																	<td align="center" style={tableStyle}><b>Exam</b></td>
																	{this.getsubjectbycls()}
																	<td style={tableStyle}><b>Rank</b></td>
																	<td style={tableStyle}><b>Attendance</b></td>
																	<td align="center" style={tableStyle}><b>Remarks</b></td>
																	<td id="tsigntop" style={tableStyle}><b>Teacher Signature</b></td>
																	<td id="prisigntop" style={tableStyle}><b>Principal Signature</b></td>
																	<td id="parsign" style={tableStyle}><b>Parents Signature</b></td>
																</tr>
																{this.state.exams.map((item, index) =>

																	<tr key={item}>
																		<td style={tableStyle}>{item.exam}</td>
																		{this.getmarkbyexam(item.id, index)}
																		<td style={tableStyle}>{this.state.rank[index]}</td>
																		<td style={tableStyle}></td>
																		{this.getremarks(item.id)}
																		<td style={tableStyle}></td>
																		<td style={tableStyle}></td>
																		<td style={tableStyle}></td>
																	</tr>
																)}
															</table>
														</td>
													</tr>
												</table>
											</Col>
										</Row>
									</CardBody>
									<iframe name="print_frame" id="print_frame" width="0" height="0" frameBorder="0" src="about:blank"></iframe>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		)
	}
}

export default ReportCard;


// WEBPACK FOOTER //
// ./src/exams/ReportCard/ReportCard.js